import { EmployeeLiteModel } from 'api-hooks/employee';
import { Expose, Type } from 'class-transformer';
import { CommonParamInput } from 'common/repositories/common.model';

export class ProductVariantLiteModel {
  id: string;

  @Expose({ name: 'complete_name' })
  completeName: string;

  @Expose({ name: 'sell_price' })
  @Type(() => Number)
  sellPrice: number;

  @Type(() => Number)
  stock: number;
}

export class ProductVariantModel {
  id: string;
  description: string;
  name: string;

  @Expose({ name: 'sell_price' })
  @Type(() => Number)
  sellPrice: number;

  @Type(() => Number)
  stock: number;
}
export class ProductListModel {
  id: string;
  code: string;
  description: string;
  name: string;

  @Expose({ name: 'product_variants' })
  @Type(() => ProductVariantModel)
  productVariants: ProductVariantModel[];
}

export class ProductListLiteModel {
  id: string;
  code: string;
  description: string;
  name: string;

  @Type(() => Number)
  stock: number;

  @Type(() => Number)
  variant: number;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;
}

//query
export type getProductsListInput = {
  params: CommonParamInput;
};

export type getProductVariantsInput = {
  params: CommonParamInput;
};

export type getProductVariantInput = {
  id: string;
};

export type getProductListInput = {
  id: string;
};

//mutation
export type ProductListMutationInput = {
  code: string;
  name: string;
  description: string;

  productVariants: {
    id?: string;
    name: string;
    sellPrice: number;
    description;
  }[];
};

export type ProductListMutationUpdateInput = {
  id: string;
  body: ProductListMutationInput;
};

export type ProductListMutationDeleteInput = {
  id: string;
};
